function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from './IconBase';

var IconBlockMediumOutline = function IconBlockMediumOutline(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24"
  }, props, {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.33 4.257c-3.93-3.219-9.735-2.995-13.402.672-3.667 3.667-3.89 9.472-.672 13.4l-.035.035.686.686.021.021.02.02.687.687.035-.035c3.928 3.219 9.733 2.995 13.4-.672 3.667-3.667 3.89-9.472.672-13.4l.035-.035-1.414-1.414-.035.035zM16.905 5.68A8.001 8.001 0 005.68 16.906L16.906 5.68zM7.094 18.32A8.001 8.001 0 0018.32 7.094L7.094 18.32z",
    clipRule: "evenodd"
  }));
};

export default IconBlockMediumOutline;